import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { calculateTaxDeduction } from '@/app/donation/guide/utils';
const FULL_TAX_DEDUCTION_LIMIT = 100000;
interface PriceInfoProps {
  amount: number;
}
export const PriceInfo = t0 => {
  const $ = _c(29);
  const {
    amount
  } = t0;
  if (amount > FULL_TAX_DEDUCTION_LIMIT) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = cn("font-700 text-Gray-900 typo-h3", "tablet:typo-h5", "mobile:typo-h5");
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] !== amount) {
      t2 = amount.toLocaleString();
      $[1] = amount;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== t2) {
      t3 = <p className={t1}>{t2}원</p>;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = cn("font-500 text-B-500 typo-body3", "tablet:typo-body4", "mobile:typo-body4");
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    if ($[6] !== amount) {
      t5 = calculateTaxDeduction(amount).total.toLocaleString();
      $[6] = amount;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    let t6;
    if ($[8] !== t5) {
      t6 = <p className={t4}>세액공제로 {t5}원 돌려받아요</p>;
      $[8] = t5;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    let t7;
    if ($[10] !== t3 || $[11] !== t6) {
      t7 = <div>{t3}{t6}</div>;
      $[10] = t3;
      $[11] = t6;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    return t7;
  }
  let t1;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("font-700 text-Gray-550 line-through typo-body1", "tablet:typo-body2", "mobile:typo-body2");
    $[13] = t1;
  } else {
    t1 = $[13];
  }
  let t2;
  if ($[14] !== amount) {
    t2 = amount.toLocaleString();
    $[14] = amount;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  let t3;
  if ($[16] !== t2) {
    t3 = <span className={t1}>{t2}원</span>;
    $[16] = t2;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  let t4;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className={cn("font-700 text-O-400 typo-h3", "tablet:typo-h5", "mobile:typo-h5")}>0원</span>;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  let t5;
  if ($[19] !== t3) {
    t5 = <div className="flex items-center gap-8">{t3}{t4}</div>;
    $[19] = t3;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = cn("font-500 text-B-500 typo-body3", "tablet:typo-body4", "mobile:typo-body4");
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== amount) {
    t7 = amount.toLocaleString();
    $[22] = amount;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== t7) {
    t8 = <p className={t6}>세액공제로 {t7}원 모두 돌려받아요</p>;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== t5 || $[27] !== t8) {
    t9 = <div>{t5}{t8}</div>;
    $[26] = t5;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
};